import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";
import useBrowser from "../../hooks/useBrowser";
import useData from "../../hooks/useData";

import EditorToolbar from "../editors/EditorToolbar";
import ListItem from "../elements/ListItem";

import SurveyModal from "../modals/SurveyModal";

const columns = [
  {
    name: "name",
    fieldType: "text",
  },
];

const Surveys = ({ projectId, clientId, onSave, onDelete }) => {
  const navigate = useNavigate();
  const { getFromServer } = useData();
  const { getMessage } = useLocalization();
  const { windowHeight } = useBrowser();

  const [openModal, setOpenModal] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [surveys, setSurveys] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const surveyList = await getFromServer({
      entityName: "Survey",
      filter: { projectId },
    });
    setSurveys(surveyList);
  };

  const handleAdd = () => {
    setOpenModal(true);
  };

  const handleSurveySave = (survey) => {
    onSave(survey);
  };

  const handleSurveySelect = (survey) => {
    if (!survey) return;

    navigate(`/survey`, {
      state: { surveyId: survey.id, projectId: projectId, clientId: clientId },
    });
  };

  return (
    <>
      <Box sx={{ height: "100%" }}>
        <EditorToolbar onAdd={handleAdd} />
        <Box
          sx={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            height: `${windowHeight - 225}px`,
            overflow: "auto",
          }}
        >
          {Array.isArray(surveys) && surveys.length > 0 ? (
            surveys.map((survey) => (
              <ListItem
                key={survey.id}
                record={survey}
                columns={columns}
                onClick={() => handleSurveySelect(survey)}
                fontStyle={{ fontSize: "12px" }}
              />
            ))
          ) : (
            <Typography>{getMessage("noRecords")}</Typography>
          )}
        </Box>
      </Box>

      <SurveyModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSave={handleSurveySave}
        surveyId={selectedSurvey}
        surveys={surveys}
      />
    </>
  );
};

export default Surveys;
